import React from 'react';

const BulkCSVUpload = ({ csvData, csvPreview, handleCSVUpload, handleBulkSubmit, downloadCSVTemplate, isSubmitting }) => (
  <div className="csv-upload-section">
    <div className="csv-instructions">
      <h2>CSV Format Instructions</h2>
      <p><strong>Required columns:</strong> city (or suburb/town), state, weekly_rent_per_person (or rent)</p>
      <p><strong>Optional columns:</strong> property_type, address, postcode, total_bedrooms, available_bedrooms, total_bathrooms, bond_required, amenities, available_from, description, pet_policy, smoking_policy, house_rules, lease_term</p>
      <div className="csv-tips">
        <h4>Tips:</h4>
        <ul>
          <li>Use <code>TBA</code>, <code>NA</code>, or leave empty for unknown values</li>
          <li>Amenities should be semicolon-separated: <code>Parking;Internet/WiFi;Garden</code></li>
          <li>Dates can be in any format: <code>2024-03-01</code> or <code>March 2024</code></li>
          <li>You can add images to each property after bulk import</li>
        </ul>
      </div>
      <button className="btn btn-secondary" onClick={downloadCSVTemplate} data-testid="download-template">
        Download CSV Template
      </button>
    </div>

    <div className="form-group">
      <label className="input-label">Upload CSV File</label>
      <input type="file" accept=".csv" onChange={handleCSVUpload} className="input-field" data-testid="csv-upload" />
    </div>

    {csvPreview.length > 0 && (
      <div className="csv-preview">
        <h3>Preview (first 5 rows)</h3>
        <div className="table-container">
          <table>
            <thead>
              <tr><th>Suburb</th><th>State</th><th>Rent/week</th><th>Type</th><th>Bedrooms</th></tr>
            </thead>
            <tbody>
              {csvPreview.map((row, idx) => (
                <tr key={`csv-row-${idx}`}>
                  <td>{row.city || row.suburb || row.town || '-'}</td>
                  <td>{row.state || '-'}</td>
                  <td>${row.weekly_rent_per_person || row.rent || row.weekly_rent || '-'}</td>
                  <td>{row.property_type || row.type || 'house'}</td>
                  <td>{row.available_bedrooms || row.available || row.total_bedrooms || row.bedrooms || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="preview-note">Total rows to import: {csvData.length}</p>
      </div>
    )}

    {csvData.length > 0 && (
      <button className="btn btn-success btn-large" onClick={handleBulkSubmit} disabled={isSubmitting} data-testid="bulk-submit">
        {isSubmitting ? 'Uploading...' : `Upload ${csvData.length} Properties`}
      </button>
    )}
  </div>
);

export default BulkCSVUpload;
